import { z } from 'zod';
import { IsoDateTimeSchema, TenantIdSchema, UuidSchema } from './common';

/**
 * Egy audit-log bejegyzés. A hash-chain miatt minden sornak van `prevHash`-e
 * (kivéve az elsőt) és saját `hash`-e — a backend tamper-evidence céljára
 * használja, a UI csak megjeleníti a hash-rövidítést.
 */
export const AuditEntrySchema = z.object({
  id: UuidSchema,
  seq: z.number().int().nonnegative(),
  tenantId: TenantIdSchema,
  actorUserId: UuidSchema.nullable(),
  actorEmail: z.string().email().nullable(),
  action: z.string(),
  targetType: z.string().nullable(),
  targetId: z.string().nullable(),
  ip: z.string().nullable(),
  payload: z.record(z.string(), z.unknown()).nullable(),
  occurredAt: IsoDateTimeSchema,
  prevHash: z.string().nullable(),
  hash: z.string(),
});
export type AuditEntry = z.infer<typeof AuditEntrySchema>;
